export default __webpack_public_path__ + "static/media/droneMultimedia.05f1c834.pdf";